require("@rails/ujs").start()
require("turbolinks").start()
require("bootstrap")

import '../stylesheets/landing.scss';